<template>
  <div class="permission-card">
    <span class="permission-card-title">{{ title }}</span>
    <p class="permission-card-subtitle">{{ subtitle }}</p>
    <div v-if="alertMessage" class="permission-card-alert">
      <mf-icon fill color="cinza-0">warning</mf-icon>
      {{ alertMessage }}
    </div>
    <mf-toggle v-model="enabled" class="permission-card-toggle" :label="toggleLabel" hide-details />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    alertMessage: {
      type: String,
      default: '',
    },
    toggleLabel: {
      type: String,
      default: 'Dísponivel para o filiado',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    enabled: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.permission-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  background: #fff;
  &-title {
    font-size: 18px;
    color: $cinza-d10;
    padding-bottom: 8px;
  }
  &-subtitle {
    font-weight: 400;
    font-size: 16px;
    color: $cinza-0;
    padding-bottom: 26px;
    margin: 0;
  }
  &-alert {
    display: flex;
    column-gap: 20px;
    padding-bottom: 26px;
    max-width: 700px;
    font-weight: 400;
    font-size: 14px;
    color: $cinza-0;
  }
  &-toggle {
    ::v-deep.v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }
  }
}
</style>
